import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';

@Injectable({ providedIn: 'root' })
export class NotificationsSettingsAnalytics extends AnalyticsBase {
  public readonly namespace = 'NotificationsSettings';
  public readonly requireViewContext = false;

  public userReset(options: { isReset: boolean }) {
    this.track('UserReset', options);
  }
}
